export const data1 = [{
        "id": "lisp",
        "label": "lisp",
        "value": 68,
        "color": "hsl(306, 70%, 50%)"
    },
    {
        "id": "ruby",
        "label": "ruby",
        "value": 20,
        "color": "hsl(247, 70%, 50%)"
    },
];

export const data2 = [{
        "id": "php",
        "label": "php",
        "value": 277,
        "color": "hsl(104, 70%, 50%)"
    },
    {
        "id": "make",
        "label": "make",
        "value": 536,
        "color": "hsl(255, 70%, 50%)"
    },
];

export const data3 = [{
        id: "javascript",
        label: "javascript",
        value: 44,
        color: "hsl(111, 90%, 90%)",
    },
    {
        id: "sass",
        label: "sass",
        value: 66,
        color: "hsl(22, 90%, 90%)",
    },
];

export const data4 = [{
        "id": "make",
        "label": "make",
        "value": 536,
        "color": "hsl(255, 70%, 50%)"
    },
    {
        "id": "scala",
        "label": "scala",
        "value": 338,
        "color": "hsl(42, 70%, 50%)"
    }
];



export const Transactions = [{
        txId: "12er5sd56",
        user: "Eslam",
        date: "2020-02-01",
        cost: "43.91",
    },
    {
        txId: "0315dsaf",
        user: "Eslam",
        date: "2023-01-05",
        cost: "133.45",
    },
    {
        txId: "01e4dsaef",
        user: "Eslam",
        date: "2020-02-01",
        cost: "43.95",
    },
    {
        txId: "51034fewds",
        user: "Eslam",
        date: "2022-11-05",
        cost: "200.95",
    },
    {
        txId: "0a123sasb",
        user: "Eslam",
        date: "2022-11-02",
        cost: "13.55",
    },
    {
        txId: "01e4dsa",
        user: "Eslam",
        date: "2020-02-01",
        cost: "43.95",
    },
    {
        txId: "120s51a",
        user: "Eslam",
        date: "2020-06-20",
        cost: "24.20",
    },
    {
        txId: "0315dsaa",
        user: "Eslam",
        date: "2023-01-05",
        cost: "133.49",
    },
];